import { render, staticRenderFns } from "./wxuserview.vue?vue&type=template&id=3d1aaa20&"
import script from "./wxuserview.vue?vue&type=script&lang=js&"
export * from "./wxuserview.vue?vue&type=script&lang=js&"
import style0 from "./wxuserview.vue?vue&type=style&index=0&id=3d1aaa20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports